<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    buses: null
  }),

  async created() {
    // if (this.$auth.user.role === 'teacher') {
    //   const buses = await Bus.fetch({ driver: this.$auth.profile.id })
    //   if (buses.length) {
    //     this.buses = buses
    //   }
    // }
  },
  methods: {
    ...mapActions('BusStudents', ['filterBusStudents']),

    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    async onFilterChanged() {
      try {
        const params = {
          student: get(this.selectedStudent, 'id', ''),
          grade: get(this.selectedGrade, 'id', ''),
          class: get(this.selectedClass, 'id', '')
        }
        await this.filterBusStudents(params)
      } catch (error) {
        this.$alert.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
